import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Col, Form, Button, Row, Toast } from 'react-bootstrap';
import modelDetailsService from '../../ModelView/components/ModelDetails/modelDetailsService';
import { modalOnCloseAction } from '../../../stores/actions/modalOnChange';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './renamePopupStyle.scss';

class RenamePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            setShow: true,
            fieldModelName: '',
            fieldVersion: '',
            showError: false,
            selectedModel: null,
            showToast: false,
            showUpdateButton: false,
            validator: {
                name: false,
                version: false,
            },
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
        };
        this.modelDetailsService = new modelDetailsService();
    }

    /**
     * Handle on close
     */
    handleClose = (api) => {
        const { selectedModel } = this.state;

        this.props.modelStatus({
            status: false,
            customerId: selectedModel.customerId,
            api: api ? api : null,
        });
        this.setState({
            show: false,
            setShow: false,
        });
    };

    /**
     * Handle on input change
     */
    handleInputChange = (event) => {
        const { showUpdateButton } = this.state;
        if (!showUpdateButton) {
            this.setState({
                showUpdateButton: true,
            });
        }

        this.setState({
            api: {
                response: {
                    message: '',
                },
            },
        });

        const value = event.target.value;
        const name = event.target.name;
        let { validator } = this.state;

        if (value === '') {
            if (name === 'fieldModelName') validator.name = true;

            if (name === 'fieldVersion') validator.version = true;
        } else {
            if (!value.trim().length) {
                if (name === 'fieldModelName') validator.name = true;
                if (name === 'fieldVersion') validator.version = true;
            } else {
                if (name === 'fieldModelName') validator.name = false;
                if (name === 'fieldVersion') validator.version = false;
            }
        }
        this.setState({
            showError: true,
            validator,
        });

        this.setState({
            [name]: value,
        });
    };

    /**
     * On form submit
     */
    formSubmit = () => {
        const { fieldModelName, fieldVersion, selectedModel } = this.state;
        this.setState({
            showError: false,
        });
        if (selectedModel.modelId) {
            if (
                fieldModelName !== '' &&
                fieldModelName.trim().length &&
                fieldVersion !== '' &&
                fieldVersion.trim().length
            ) {
                let params = {
                    modelId: selectedModel.modelId,
                    modelVersionId: selectedModel.modelVersionId,
                    modelName: fieldModelName,
                    modelVersion: fieldVersion,
                    customerId: selectedModel.customerId,
                };

                this.modelDetailsService.renameModelOrVersion(params).then((res) => {
                    if (res && res.status === 'Success') {
                        this.setState({
                            showError: false,
                        });
                        const api = {
                            response: {
                                status: res.status,
                                message: res.message,
                            },
                        };
                        // this.toggleToast();
                        this.handleClose(api);
                    } else {
                        this.setState({
                            showError: true,
                            api: {
                                response: {
                                    status: res.status,
                                    message: res.message,
                                },
                            },
                        });
                        // this.toggleToast();
                    }
                });
            } else {
                this.setState({
                    showError: true,
                });
            }
        }
    };

    /**
     * Component mounting invoking func
     */
    componentDidMount() {
        if (this.props && this.props.selectedModel.modelPayload && this.props.selectedModel.modelPayload) {
            const selectedModel = this.props.selectedModel.modelPayload;
            this.setState({
                selectedModel: selectedModel,
                fieldModelName: selectedModel.modelName,
                fieldVersion: selectedModel.version,
            });
        }
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    /**
     * Rendering ui elements
     */
    render() {
        const { show, validator, showError, fieldModelName, fieldVersion, showToast, api, showUpdateButton } =
            this.state;
        let selectedModel = null;

        if (this.props && this.props.selectedModel.modelPayload && this.props.selectedModel.modelPayload) {
            selectedModel = this.props.selectedModel.modelPayload;
        }

        return (
            <>
                <Modal className="modal-rename" show={show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Rename Model</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="">
                            <Col md={12} className="pt-2">
                                <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                                    <Toast.Header
                                        className={` ${api.response.status !== 'Failure' ? 'success' : 'error'}`}
                                    >
                                        <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                                        <strong className="mr-auto">{api.response.status}</strong>
                                    </Toast.Header>
                                    <Toast.Body>{api.response.message}</Toast.Body>
                                </Toast>
                            </Col>
                        </Row>
                        <Form.Group>
                            <Row className="mb-2 previous-data">
                                <Col md={4}>
                                    <label>Current Model Name: </label>
                                </Col>
                                <Col md={8} className="pl-0">
                                    <div className="current-data">
                                        <span className="ml-1">{selectedModel?.modelName}</span>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-2 previous-data">
                                <Col md={4}>
                                    <label>Current Version: </label>
                                </Col>
                                <Col md={8} className="pl-0">
                                    <div className="current-data">
                                        <span className="ml-1">{selectedModel?.version}</span>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <Row className="mb-2">
                                <Col md={4} className="text-left">
                                    <Form.Label className="model-field-label">
                                        New Model Name
                                        {/* <span className="semi-col">:</span> */}
                                    </Form.Label>
                                </Col>
                                <Col md={8} className="pl-0">
                                    <Form.Control
                                        type="text"
                                        id="new-name"
                                        size="sm"
                                        placeholder="New Model Name"
                                        name="fieldModelName"
                                        className={` ${
                                            (validator.name || (api.response && api.response.message)) && showError
                                                ? 'form-error'
                                                : ''
                                        }`}
                                        value={fieldModelName}
                                        onChange={this.handleInputChange}
                                        autoComplete="none"
                                    />
                                    {validator.name && showError ? (
                                        <span className="error">Name is required</span>
                                    ) : null}
                                    {api.response && api.response.message && showError ? (
                                        <span className="error">{api.response.message}</span>
                                    ) : null}
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Col md={4} className="text-left">
                                    <Form.Label className="model-field-label">
                                        New Version
                                        {/* <span className="semi-col">:</span> */}
                                    </Form.Label>
                                </Col>
                                <Col md={8} className="pl-0">
                                    <Form.Control
                                        id="new-version"
                                        type="text"
                                        size="sm"
                                        placeholder="New Version"
                                        name="fieldVersion"
                                        className={` ${validator.version && showError ? 'form-error' : ''}`}
                                        onChange={this.handleInputChange}
                                        value={fieldVersion}
                                        autoComplete="none"
                                    />
                                    {validator.version && showError ? (
                                        <span className="error">Version is required</span>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={6} md={6} className="text-right col-6">
                                    <Button
                                        type="button"
                                        id="update-btn"
                                        disabled={showUpdateButton ? null : 'disabled'}
                                        className="submit-btn"
                                        variant="primary"
                                        size="sm"
                                        onClick={this.formSubmit}
                                    >
                                        Update
                                    </Button>
                                </Col>
                                <Col sm={6} md={6} className="text-left col-6">
                                    <Button
                                        type="button"
                                        id="cancel-btn"
                                        className="cancel-btn"
                                        variant="secondary"
                                        size="sm"
                                        onClick={this.handleClose}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

const MapDispatchToProps = (dispatch) => {
    return {
        modelStatus: (params) => dispatch(modalOnCloseAction(params)),
    };
};

RenamePopup.propTypes = {
    modelStatus: PropTypes.object.isRequired,
    selectedModel: PropTypes.object.isRequired,
};

/**
 * Mapping redux state into props
 */
const MapStateToProps = (state) => {
    return {
        selectedModel: state.modalOnOpenAction,
    };
};

export default connect(MapStateToProps, MapDispatchToProps)(RenamePopup);
